function pathHandle(uri) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  if (basePath && uri.includes(basePath)) {
    return uri;
  }
  if (/^\/?(mall|read|sherlock|edu|pc)\/.*/.test(uri)) {
    return uri;
  }
  if (/^http/.test(uri) || /^\/\//.test(uri)) {
    return uri;
  } else if (/^\//.test(uri)) {
    return "".concat(basePath).concat(uri);
  }
  return uri;
}
export { pathHandle as p };
